var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"page-transition"}},[(_vm.isOpen)?_c('div',{staticClass:"fixed inset-0 bg-gray-100 p-8 shadow-xl overflow-y-auto md:left-80 md:shadow-none"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }